import { render } from "./BaseBackPopup.vue?vue&type=template&id=6bdf1bed&scoped=true"
import script from "./BaseBackPopup.vue?vue&type=script&lang=js"
export * from "./BaseBackPopup.vue?vue&type=script&lang=js"

import "./BaseBackPopup.vue?vue&type=style&index=0&id=6bdf1bed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdf1bed"]])

export default __exports__